(function () {
  function money(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || (window.theme && theme.moneyFormat) || '${{amount}}');
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function ensureAccPanel(details) {
    var body = details.querySelector('.gg-pdp__acc-body');
    if (!body) return null;
    var panel = details.querySelector('.gg-pdp__acc-panel');
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'gg-pdp__acc-panel';
    var inner = document.createElement('div');
    inner.className = 'gg-pdp__acc-panel-inner';
    body.parentNode.insertBefore(panel, body);
    panel.appendChild(inner);
    inner.appendChild(body);
    return panel;
  }

  function setPanelHeight(panel, value) {
    panel.style.height = value;
  }

  function openAccordion(details, panel) {
    if (details.classList.contains('is-animating')) return;
    details.classList.add('is-animating');
    details.setAttribute('open', '');
    details.classList.add('is-open');

    if (prefersReducedMotion()) {
      setPanelHeight(panel, 'auto');
      details.classList.remove('is-animating');
      return;
    }

    setPanelHeight(panel, '0px');
    panel.offsetHeight;
    setPanelHeight(panel, panel.scrollHeight + 'px');

    var onEnd = function (e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      setPanelHeight(panel, 'auto');
      details.classList.remove('is-animating');
    };
    panel.addEventListener('transitionend', onEnd);
  }

  function closeAccordion(details, panel) {
    if (details.classList.contains('is-animating')) return;
    details.classList.add('is-animating');
    details.classList.remove('is-open');

    if (prefersReducedMotion()) {
      details.removeAttribute('open');
      setPanelHeight(panel, '0px');
      details.classList.remove('is-animating');
      return;
    }

    setPanelHeight(panel, panel.scrollHeight + 'px');
    panel.offsetHeight;
    setPanelHeight(panel, '0px');

    var onEnd = function (e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      details.removeAttribute('open');
      details.classList.remove('is-animating');
    };
    panel.addEventListener('transitionend', onEnd);
  }

  function initAccordions(scope) {
    var roots = (scope || document).querySelectorAll('[data-gg-accordions]');
    roots.forEach(function (group) {
      group.querySelectorAll('details.gg-pdp__acc').forEach(function (details) {
        if (details.__ggAccBound) return;
        details.__ggAccBound = true;

        var summary = details.querySelector('summary');
        var panel = ensureAccPanel(details);
        if (!summary || !panel) return;

        if (details.hasAttribute('open')) {
          details.classList.add('is-open');
          setPanelHeight(panel, 'auto');
        } else {
          details.classList.remove('is-open');
          setPanelHeight(panel, '0px');
        }

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (details.classList.contains('is-animating')) return;
          if (details.hasAttribute('open')) closeAccordion(details, panel);
          else openAccordion(details, panel);
        });
      });
    });
  }

  function initProduct(root) {
    var jsonEl = root.querySelector('[data-gg-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var variantInput = root.querySelector('[data-gg-variant-id]');
    var priceEl = root.querySelector('[data-gg-price]');
    var atc = root.querySelector('[data-gg-atc]');
    var optionInputs = root.querySelectorAll('[data-gg-option]');
    var qtyInput = root.querySelector('[data-gg-qty]');
    var buildProp = root.querySelector('[data-gg-build-prop]');
    var buildDetails = root.querySelector('[data-gg-build-details]');
    var stockNoteEl = root.querySelector('[data-gg-stock-note]');
    var modeHint = root.querySelector('[data-gg-mode-hint]');
    var customFields = root.querySelector('[data-gg-custom-fields]');
    var headBanner = root.querySelector('[data-gg-head-banner]');
    var buildOptionSets = root.querySelectorAll('[data-gg-build-option]');
    var showModes = root.getAttribute('data-show-modes') === 'true';
    var headOnlyPercent = Number(root.getAttribute('data-head-only-percent') || 65);
    var defaultMode = root.getAttribute('data-default-mode') || 'stock';
    var showCustomNotes = root.getAttribute('data-show-custom-notes') === 'true';
    var mode = defaultMode === 'customize' || defaultMode === 'head' ? defaultMode : 'stock';
    var HEAD = 'Head only';
    var stockDefaults = {};

    buildOptionSets.forEach(function (fieldset) {
      var checked = fieldset.querySelector('[data-gg-option]:checked:not([data-gg-head-option-value])');
      var first = fieldset.querySelector('[data-gg-option]:not([data-gg-head-option-value])');
      var name = fieldset.getAttribute('data-option-name');
      if (name && (checked || first)) stockDefaults[name] = (checked || first).value;
    });

    var hints = {
      stock: 'In stock. Ready to ship.',
      customize: 'Custom build. About 10 days to ship.',
      head: 'Head only — shaft and grip not included. Ships in 3–5 business days.'
    };

    function isBuildName(name) {
      var n = String(name || '').toLowerCase();
      return n.indexOf('shaft') !== -1 || n.indexOf('flex') !== -1 || n.indexOf('grip') !== -1;
    }

    function selectedOptions() {
      var map = {};
      optionInputs.forEach(function (input) {
        if (input.checked) {
          var name = input.name.replace(/^options\[/, '').replace(/\]$/, '');
          map[name] = input.value;
        }
      });
      return map;
    }

    function findVariant() {
      var selected = selectedOptions();
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, idx) {
          var optionName = product.options[idx];
          return selected[optionName] === opt;
        });
      });
    }

    function fullClubComparePrice(headVariant) {
      if (!headVariant) return 0;
      var selected = selectedOptions();
      var match = product.variants.find(function (variant) {
        if (variant.options.some(function (opt) { return opt === HEAD; })) return false;
        return product.options.every(function (optionName, idx) {
          if (isBuildName(optionName)) return true;
          return variant.options[idx] === selected[optionName];
        });
      });
      if (match) return match.price;
      // fallback estimate from head price
      return Math.round(headVariant.price / (headOnlyPercent / 100));
    }

    function modeLabel() {
      if (mode === 'head') return 'Head only';
      if (mode === 'customize') return 'Customize';
      return 'Stock';
    }

    function syncBuildMeta(variant) {
      if (!buildProp) return;
      buildProp.value = modeLabel();
      if (!buildDetails) return;
      var selected = selectedOptions();
      var bits = [];
      Object.keys(selected).forEach(function (key) {
        if (selected[key] === HEAD) return;
        bits.push(key + ': ' + selected[key]);
      });
      if (mode === 'head' && variant) bits.push('Head-only price: ' + money(variant.price));
      buildDetails.value = bits.join(' · ');
    }

    function ensureNonHeadSelection() {
      buildOptionSets.forEach(function (fieldset) {
        var name = fieldset.getAttribute('data-option-name');
        var current = fieldset.querySelector('[data-gg-option]:checked');
        if (current && current.value === HEAD) {
          var target = stockDefaults[name];
          var input = Array.prototype.find.call(
            fieldset.querySelectorAll('[data-gg-option]'),
            function (el) { return el.value === target; }
          ) || fieldset.querySelector('[data-gg-option]:not([data-gg-head-option-value])');
          if (input) input.checked = true;
        }
      });
    }

    function applyModeUI() {
      var isHead = mode === 'head';
      var isCustom = mode === 'customize';

      buildOptionSets.forEach(function (fieldset) {
        var name = fieldset.getAttribute('data-option-name');
        if (isHead) {
          fieldset.hidden = true;
          var headInput = fieldset.querySelector('[data-gg-head-option-value]');
          fieldset.querySelectorAll('[data-gg-option]').forEach(function (input) {
            input.checked = input.value === HEAD;
            // keep enabled so value is reliable; fieldset is hidden
            input.disabled = false;
          });
          if (headInput) headInput.checked = true;
          else if (stockDefaults[name]) {
            // fallback if head variants not seeded yet
            fieldset.querySelectorAll('[data-gg-option]').forEach(function (input) {
              input.checked = input.value === stockDefaults[name];
            });
          }
        } else {
          fieldset.hidden = false;
          fieldset.querySelectorAll('[data-gg-option]').forEach(function (input) {
            input.disabled = false;
          });
          ensureNonHeadSelection();
        }
      });

      // Never show "Head only" swatches in stock/customize pickers
      root.querySelectorAll('[data-gg-head-value]').forEach(function (el) {
        el.hidden = true;
      });

      if (customFields) {
        var showNotes = showCustomNotes && isCustom;
        customFields.hidden = !showNotes;
        customFields.querySelectorAll('[data-gg-custom-field]').forEach(function (input) {
          input.disabled = !showNotes;
          if (!showNotes) input.value = '';
        });
      }
      if (headBanner) headBanner.hidden = !isHead;

      var noteKey = mode === 'head' ? 'data-note-head' : mode === 'customize' ? 'data-note-customize' : 'data-note-stock';
      var noteText = root.getAttribute(noteKey) || hints[mode] || '';
      if (stockNoteEl) stockNoteEl.textContent = noteText;
      if (modeHint) modeHint.textContent = noteText;

      root.classList.toggle('is-mode-stock', mode === 'stock');
      root.classList.toggle('is-mode-customize', isCustom);
      root.classList.toggle('is-mode-head', isHead);
    }

    function syncVariant() {
      var variant = findVariant() || product.variants[0];
      if (!variant) return;
      variantInput.value = variant.id;
      var cents = variant.price;
      var compare = 0;
      if (mode === 'head') {
        compare = fullClubComparePrice(variant);
        // If head variant missing, fall back to percent display only (should not happen after seed)
        if (!variant.options.some(function (opt) { return opt === HEAD; })) {
          cents = Math.round(variant.price * (headOnlyPercent / 100));
          compare = variant.price;
        }
      } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare = variant.compare_at_price;
      }

      if (priceEl) {
        var html = money(cents);
        if (mode === 'head') {
          html += ' <span class="gg-pdp__price-tag">Head only</span>';
          if (compare > cents) html += ' <s class="gg-pdp__compare">' + money(compare) + '</s>';
        } else if (compare > cents) {
          html += ' <s class="gg-pdp__compare">' + money(compare) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (atc) {
        atc.disabled = !variant.available;
        var label = atc.querySelector('[data-gg-atc-label]');
        if (label) {
          label.innerHTML = variant.available
            ? 'Add to cart — <span data-gg-atc-price">' + money(cents) + '</span>'
            : 'Sold out';
        }
      }
      syncBuildMeta(variant);
    }

    function setMode(next) {
      mode = next;
      root.querySelectorAll('[data-gg-mode]').forEach(function (b) {
        var active = b.getAttribute('data-gg-mode') === mode;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      applyModeUI();
      syncVariant();
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (mode !== 'head' && input.value === HEAD) return;
        syncVariant();
      });
    });

    if (showModes) {
      root.querySelectorAll('[data-gg-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setMode(btn.getAttribute('data-gg-mode'));
        });
      });
      setMode(mode);
    } else {
      syncVariant();
    }

    var minus = root.querySelector('[data-gg-qty-minus]');
    var plus = root.querySelector('[data-gg-qty-plus]');
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
      });
      plus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + 1);
      });
    }

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gg-thumb]'));
    var mainImg = root.querySelector('#GgProductMainImage');
    var track = root.querySelector('.gg-pdp__thumbs-track');
    function setThumb(i) {
      if (!thumbs.length || !mainImg) return;
      var idx = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === idx);
      });
      mainImg.src = thumbs[idx].getAttribute('data-media-src');
      mainImg.srcset = '';
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        setThumb(i);
      });
    });
    var prev = root.querySelector('[data-gg-thumb-prev]');
    var next = root.querySelector('[data-gg-thumb-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        var current = thumbs.findIndex(function (t) {
          return t.classList.contains('is-active');
        });
        setThumb(current - 1);
        if (track) track.scrollLeft -= 80;
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        var current = thumbs.findIndex(function (t) {
          return t.classList.contains('is-active');
        });
        setThumb(current + 1);
        if (track) track.scrollLeft += 80;
      });
    }
  }

  function initFit(root) {
    var iron = root.querySelector('[data-gg-fit-iron]');
    var driver = root.querySelector('[data-gg-fit-driver]');
    var skill = root.querySelector('[data-gg-fit-skill]');
    var ageInput = root.querySelector('[data-gg-fit-age]');
    var handInput = root.querySelector('[data-gg-fit-hand]');
    var tempo = 'moderate';
    var defaultAge = Number(root.getAttribute('data-fit-age') || 36);

    function calculate() {
      var engine = window.GgFittingEngine;
      if (!engine) return;

      var ironSpeed = Number(iron.value);
      var driverSpeed = Number(driver.value);
      var age = ageInput ? Number(ageInput.value) : defaultAge;
      var hand = handInput ? Number(handInput.value) : 5.8;

      var result = engine.recommend({
        ironSpeed: ironSpeed,
        driverSpeed: driverSpeed,
        age: age,
        tempo: tempo,
        skill: skill ? skill.value : 'intermediate',
        handMeasure: hand,
        height: 64,
        wtf: 32
      });

      var ageVal = root.querySelector('[data-gg-fit-age-val]');
      if (ageVal) ageVal.textContent = String(age);
      var handVal = root.querySelector('[data-gg-fit-hand-val]');
      if (handVal) handVal.textContent = hand.toFixed(1) + '"';

      root.querySelector('[data-gg-fit-iron-val]').textContent = ironSpeed + ' mph';
      root.querySelector('[data-gg-fit-driver-val]').textContent = driverSpeed + ' mph';
      root.querySelector('[data-gg-profile-iron]').textContent = ironSpeed + ' mph';
      root.querySelector('[data-gg-profile-driver]').textContent = driverSpeed + ' mph';
      root.querySelector('[data-gg-profile-skill]').textContent =
        skill && skill.value === 'beginner'
          ? 'Beginner'
          : skill && skill.value === 'advanced'
            ? 'Advanced / Elite'
            : 'Intermediate';
      root.querySelector('[data-gg-profile-tempo]').textContent = result.tempoLabel;
      root.querySelector('[data-gg-profile-age]').textContent = String(age);
      root.querySelector('[data-gg-moi]').textContent = result.moi.toLocaleString('en-US');

      var flexEl = root.querySelector('[data-gg-profile-flex]');
      if (flexEl) flexEl.textContent = result.flex;
      var lineEl = root.querySelector('[data-gg-profile-line]');
      if (lineEl) lineEl.textContent = result.series.label;
      var gripEl = root.querySelector('[data-gg-profile-grip]');
      if (gripEl) gripEl.textContent = result.grip;

      root.querySelector('[data-gg-moi-label]').textContent = result.moiCategory;
      var tempoNote =
        result.moiTempoAdj === 0
          ? 'Moderate tempo — no MOI offset'
          : result.moiTempoAdj > 0
            ? 'Aggressive tempo adds +25 MOI'
            : 'Smooth tempo subtracts −25 MOI';
      root.querySelector('[data-gg-moi-copy]').textContent =
        'Specific target ' +
        result.moi.toLocaleString('en-US') +
        ' kg·cm² from the continuum grid. ' +
        tempoNote +
        '.';

      var seriesEl = root.querySelector('[data-gg-fit-series]');
      if (seriesEl) {
        seriesEl.textContent = 'Suggested: ' + result.series.label + ' · Flex ' + result.flex;
      }
      var shaftEl = root.querySelector('[data-gg-fit-shaft]');
      if (shaftEl) {
        shaftEl.textContent = result.shaftCategory + ' · ' + result.shaftModel;
      }

      var hint = root.querySelector('[data-gg-tempo-hint]');
      if (hint) hint.textContent = tempoNote;

      var pct = (result.moi - 2380) / (2880 - 2380);
      pct = Math.max(0, Math.min(1, pct));
      var arc = root.querySelector('[data-gg-gauge-arc]');
      if (arc) {
        var len = 251;
        arc.style.strokeDashoffset = String(len * (1 - pct));
      }
      var needle = root.querySelector('[data-gg-gauge-needle]');
      if (needle) {
        var angle = -90 + pct * 180;
        needle.setAttribute('transform', 'rotate(' + angle + ' 100 100)');
      }
    }

    root.querySelectorAll('[data-gg-tempo]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        tempo = btn.getAttribute('data-gg-tempo');
        root.querySelectorAll('[data-gg-tempo]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        calculate();
      });
    });

    [iron, driver, skill, ageInput, handInput].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', calculate);
      el.addEventListener('change', calculate);
    });

    calculate();
  }

  function boot() {
    document.querySelectorAll('[data-gg-product]').forEach(initProduct);
    document.querySelectorAll('[data-gg-fit]').forEach(initFit);
    initAccordions(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
(function () {
  function connectPlayerFit() {
    document.querySelectorAll('[data-playerfit]').forEach(function (fitting) {
      if (fitting.__playerFitConnected) return;

      var productId = fitting.getAttribute('data-playerfit-product');
      var matchingProducts = Array.from(
        document.querySelectorAll('[data-gg-product]')
      ).filter(function (product) {
        return product.getAttribute('data-product-id') === productId;
      });

      // Avoid attaching answers to the wrong product.
      if (matchingProducts.length !== 1) return;

      var form = matchingProducts[0].querySelector('form.gg-pdp__form');
      if (!form || !form.id) return;

      var fields = Array.from(
        fitting.querySelectorAll('select[name^="properties["], input[name^="properties["]')
      );
      var requiredFields = fields.filter(function (field) {
        return field.required && field.type !== 'file';
      });

      if (!requiredFields.length) return;

      var answerFields = fields.filter(function (field) {
  return field.tagName === 'SELECT';
});

var answerCopies = answerFields.map(function (field) {
  // Keep the visible field outside the form to avoid duplicate values.
  field.removeAttribute('form');

  var copy = document.createElement('input');
  copy.type = 'hidden';
  copy.name = field.name;
  copy.setAttribute('data-playerfit-answer', '');
  form.appendChild(copy);

  return { field: field, copy: copy };
});

function syncAnswers() {
  answerCopies.forEach(function (answer) {
    answer.copy.value = answer.field.value;
  });
}

fitting.addEventListener('input', syncAnswers);
fitting.addEventListener('change', syncAnswers);
syncAnswers();


      // Allows file inputs to be submitted by a standard form submission.
      // Other cart scripts must also preserve file data.
      form.enctype = 'multipart/form-data';

      var confirmation = document.createElement('div');
      confirmation.className =
        fitting.className.split(' ')[0] + '__notice';
      confirmation.setAttribute('role', 'status');
      confirmation.setAttribute('aria-live', 'polite');
      confirmation.hidden = true;

      var title = document.createElement('strong');
      title.textContent = 'Your PlayerFit is Ready.';

      var message = document.createElement('p');
      message.textContent =
        "We've captured your players measurements and swing characteristics. " +
        'Your irons will be configured specifically for their game.';

      confirmation.appendChild(title);
      confirmation.appendChild(message);
if (String(productId) === '9563673886908') {
  title.textContent =
    'Your player specs are complete. Next, click ADD TO CART.';

  message.remove();

  confirmation.style.cssText =
    'background:#fff3b0;color:#292100;padding:12px 16px;' +
    'border:1px solid #b58a00;border-radius:4px;' +
    'font-weight:600;line-height:1.5;margin:12px 0;';
}

      var buyArea = form.querySelector('.gg-pdp__buy');
      if (!buyArea) return;
      buyArea.before(confirmation);

      function firstInvalidField() {
        return requiredFields.find(function (field) {
          return !field.disabled && !field.checkValidity();
        });
      }

      function updateConfirmation() {
        confirmation.hidden = Boolean(firstInvalidField());
      }

      function guardPurchase(event) {
  syncAnswers();
  if (String(productId) === '9563673886908') {
  const uploadInputs = [
    ...document.querySelectorAll(
      '#uploadery-container input[type="hidden"]'
    )
  ];

  ['down_the_line_driver_swing', 'face_on_driver_swing']
    .forEach(key => {
      const name = 'properties[' + key + ']';
      const source = uploadInputs.find(input => input.name === name);
      const value = source ? source.value.trim() : '';

      let target = [...form.querySelectorAll('input')]
        .find(input => input.name === name);

      if (!value.startsWith('https://')) {
        if (target && target.dataset.demoVideo === 'true') {
          target.remove();
        }
        return;
      }

      if (!target) {
        target = document.createElement('input');
        target.type = 'hidden';
        target.name = name;
        target.dataset.demoVideo = 'true';
        form.appendChild(target);
      }

      target.value = value;
    });
}

  var invalid = firstInvalidField();

        if (!invalid) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        confirmation.hidden = true;
        invalid.focus();
        invalid.reportValidity();
      }

      fitting.addEventListener('change', updateConfirmation);

      // Explicit validation because the existing form uses novalidate.
      form.addEventListener('submit', guardPurchase, true);

      form.querySelectorAll('[type="submit"]').forEach(function (button) {
        button.addEventListener('click', guardPurchase, true);
      });

      updateConfirmation();
      fitting.__playerFitConnected = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectPlayerFit);
  } else {
    connectPlayerFit();
  }

  document.addEventListener('shopify:section:load', connectPlayerFit);
})();
